import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import MasterLayout from '@layouts/master.vue';

import EnquiriesMaster from '@pages/enquiries/master.vue';
import EnquiriesIndex from '@pages/enquiries/index.vue';
import EnquiriesCreate from '@pages/enquiries/create.vue';
import EnquiriesEdit from '@pages/enquiries/edit.vue';
import EnquiriesShow from '@pages/enquiries/show.vue';

import PatientsMaster from '@pages/patients/master.vue';
import PatientsIndex from '@pages/patients/index.vue';
import PatientsCreate from '@pages/patients/create.vue';
import PatientsEdit from '@pages/patients/edit.vue';

import SessionsMaster from '@pages/sessions/master.vue';
import SessionsIndex from '@pages/sessions/index.vue';

import InvoicesMaster from '@pages/invoices/master.vue';
import InvoicesIndex from '@pages/invoices/index.vue';
import InvoicesShow from '@pages/invoices/show.vue';

import UsersMaster from '@pages/users/master.vue';
import UsersIndex from '@pages/users/index.vue';
import UsersCreate from '@pages/users/create.vue';
import UsersShow from '@pages/users/show.vue';

import ProfilesMaster from '@pages/profiles/master.vue';
import ProfilesEdit from '@pages/profiles/edit';

import ClientsMaster from '@pages/clients/master.vue';
import ClientsEdit from '@pages/clients/edit';

import AuthLogin from '@pages/auth/login.vue';
import AuthRegister from '@pages/auth/register.vue';
import AuthForgotPassword from '@pages/auth/forgot.vue';
import AuthResetPassword from '@pages/auth/reset.vue';

import ReportsMaster from '@pages/reports/master.vue';
import ReportsIndex from '@pages/reports/index.vue';
import ReportsShow from '@pages/reports/show.vue';

import ErrorShow from '@pages/errors/show.vue';

import authService from '@api/auth';

export default new VueRouter({
	mode: 'history',
	routes: [
		{ path: '/error/:status', component: ErrorShow },
		{ path: '/login', component: AuthLogin, beforeEnter: authService.redirectToMain },
		{ path: '/forgot-password', component: AuthForgotPassword, beforeEnter: authService.redirectToMain },
		{ path: '/finish-sign-up', component: AuthRegister, beforeEnter: authService.redirectToLogin },
		{ path: '/reset/new-password', component: AuthResetPassword, beforeEnter: authService.redirectToMain },
		{
			path: '/',
			component: MasterLayout,
			meta: { breadCrumb: 'Home', title: 'Dashboard' },
			beforeEnter: authService.redirectToLogin,
			children: [
				{ path: '/', beforeEnter: authService.redirectToMain },
				{
					path: '/enquiries',
					component: EnquiriesMaster,
					meta: { breadCrumb: 'Enquiries', title: 'Enquiries' },
					children: [
						{ path: '', component: EnquiriesIndex },
						{
							path: 'create',
							component: EnquiriesCreate,
							meta: { breadCrumb: 'Create', title: 'Create Enquiry' }
						},
						{
							path: ':id/edit',
							component: EnquiriesEdit,
							meta: { breadCrumb: 'Edit', title: 'Edit Enquiry' }
						},
						{
							path: ':id',
							component: EnquiriesShow,
							meta: { breadCrumb: 'View', title: 'View Enquiry' }
						}
					]
				},
				{
					path: '/patients',
					component: PatientsMaster,
					meta: { breadCrumb: 'Patients', title: 'Patients' },
					children: [
						{ path: '', component: PatientsIndex },
						{
							path: 'create',
							component: PatientsCreate,
							meta: { breadCrumb: 'Create', title: 'Create Patient' }
						},
						{
							path: ':id/edit',
							component: PatientsEdit,
							meta: { breadCrumb: 'Edit', title: 'Edit Patient' }
						}
					]
				},
				{
					path: '/sessions',
					component: SessionsMaster,
					meta: { breadCrumb: 'Sessions', title: 'Sessions' },
					children: [{ path: '', component: SessionsIndex }]
				},
				{
					path: '/invoices',
					component: InvoicesMaster,
					meta: { breadCrumb: 'Invoices', title: 'Invoices' },
					children: [
						{ path: '', component: InvoicesIndex },
						{
							path: ':id',
							component: InvoicesShow,
							meta: { breadCrumb: 'View', title: 'View Invoice' }
						}
					]
				},
				{
					path: '/users',
					component: UsersMaster,
					meta: { breadCrumb: 'Users', title: 'Users' },
					children: [
						{ path: '', component: UsersIndex },
						{
							path: 'create',
							component: UsersCreate,
							meta: { breadCrumb: 'Create', title: 'Create User' }
						},
						{
							path: ':id',
							component: UsersShow,
							meta: { breadCrumb: 'View', title: 'View User' }
						}
					]
				},
				{
					path: '/profile',
					component: ProfilesMaster,
					meta: { breadCrumb: 'My Profile', title: 'My Profile' },
					children: [{ path: '', component: ProfilesEdit }]
				},
				{
					path: '/clients/edit',
					component: ClientsMaster,
					meta: { breadCrumb: 'Client Profile', title: 'Client Profile' },
					children: [{ path: '', component: ClientsEdit }]
				},
				{
					path: '/reports',
					component: ReportsMaster,
					meta: { breadCrumb: 'Reports', title: 'Reports' },
					children: [
						{ path: '', component: ReportsIndex },
						{
							path: ':id',
							component: ReportsShow,
							meta: { breadCrumb: 'View', title: 'View Report' }
						}
					]
				}
			]
		},
		{
			path: '*',
			beforeEnter: () => {
				window.location.href = '/error/404';
			}
		}
	]
});
